import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import HomePage from './pages/Home/HomePage';
import Footer from './components/Footer/Footer';
import AboutUs from './pages/About/AboutUs';
import Desk from './pages/About/Desk';
import CommitteesPage from './pages/About/CommitteesPage';
import AffiliationPage from './pages/Affiliation/AffiliationPage';
import AdmissionPage from './pages/Admission/AdmissionPage';
import NSSPage from './pages/Nss/NSSPage';
import ContactPage from './pages/contact/ContactPage';
import GrievancePage from './pages/Grievance/GrievancePage';
import ScrollToTop from './components/ScrollToTop';
import ECCoursePage from './pages/EC-course/eccourse';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard/Dashboard';
import AuthPage from './pages/AuthPage/AuthPage';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import LecturerDashboard from './pages/LecturerDashboard/LecturerDashboard';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import AlumniPage from './pages/Alumni/AlumniPage';


const App: React.FC = () => {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<AuthPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/about/desk" element={<Desk />} />
        <Route path="/about/committees" element={<CommitteesPage />} />
        <Route path="/affiliation" element={<AffiliationPage />} />
        <Route path="/admission" element={<AdmissionPage />} />
        <Route path="/nss" element={<NSSPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/alumni" element={<AlumniPage />} />
        <Route path="/grievance" element={<GrievancePage />} />
        <Route path="/ec-course" element={<ECCoursePage />} />
        <Route path="/grievance/lecturerdashboard" element={<ProtectedRoute element={<LecturerDashboard />} />} />
        <Route path="/grievance/admindashboard" element={<ProtectedRoute element={<AdminDashboard />} />} />
        <Route path="/grievance/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
